import { injectable, inject } from 'inversify';
import { DslRuntimeModule, moduleImplementation, RuntimeValue,
         runtimeValue, param, StringType, BooleanType,
         secondsAsDuration, Duration, DurationType, SectionType } from '@xlearn/common';
import { SectionStateQuerySymbol, SectionStateQuery } from './section-state-query';

@injectable()
export class SectionDslRuntimeModule implements DslRuntimeModule {

  public readonly ns = 'section';

  constructor(
    @inject(SectionStateQuerySymbol)
    private sectionStateStore: SectionStateQuery) {

  }

  get implementations() {
    return [
      moduleImplementation('object_reference', (params) => this.sectionObjectReference(params), param(StringType)),
      moduleImplementation('completed', (params) => this.isSectionCompleted(params), param(SectionType)),
      moduleImplementation('time', (params) => this.sectionTime(params), param(SectionType))
    ];
  }

  private sectionObjectReference(params: RuntimeValue[]): RuntimeValue {
    const id = params[0].value;

    return runtimeValue({ id }, SectionType);
  }

  private isSectionCompleted(params: RuntimeValue[]): RuntimeValue {

    const section = params[0].value as SectionReference;

    const found = this.sectionStateStore.states.find((x) => x.id === section.id);
    const completed = found ? found.status === 'completed' : false;

    return runtimeValue(completed, BooleanType);
  }

  private sectionTime(params: RuntimeValue[]): RuntimeValue {

    const section = params[0].value as SectionReference;
    const found = this.sectionStateStore.states.find((x) => x.id === section.id);
    const seconds = found ? found.durationSeconds : 0;

    const duration = secondsAsDuration(seconds);
    return runtimeValue<Duration>(duration, DurationType);
  }
}

interface SectionReference {
  id: string;
}


